import { useState, useEffect } from 'react';
import { ProductoDetallePublico } from '../types';
import {
  getProductoDetalle,
  getProductoDetallePorProveedorProducto,
} from '../services/catalogoDetalleService';

/**
 * Carga el detalle del producto para el modal.
 *
 * Prefiere resolver por `proveedorProductoId` (vía del catálogo en modo proveedor:
 * el producto puede no tener canónico) y cae a `canonicoId` cuando no hay
 * proveedor_producto (p. ej. modal abierto desde una línea de cotización).
 */
export function useProductoDetalle(
  canonicoId: number | null,
  proveedorProductoId: number | null,
  open: boolean,
) {
  const [detalle, setDetalle] = useState<ProductoDetallePublico | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const porProveedor = proveedorProductoId !== null;
    const id = porProveedor ? proveedorProductoId : canonicoId;

    if (!open || id === null) {
      setDetalle(null);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const fetcher = porProveedor
      ? getProductoDetallePorProveedorProducto(id)
      : getProductoDetalle(id);

    fetcher
      .then((data) => {
        if (!cancelled) setDetalle(data);
      })
      .catch((err: Error) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [canonicoId, proveedorProductoId, open]);

  return { detalle, loading, error };
}
